import React, { useState, useEffect } from 'react';
import '../Login/Login.css';
import { getPackageList } from '../../services/userpackage';
import { clearPackageSelection } from '../../helpers/selection';
import UserPackagePurchased from './UserPackagePurchased';
import UserPackageSummary from './UserPackageSummary';


function UserPackage() {

    const [packageList, setPackageList] = useState();
    const [purchased, setPurchased] = useState(false);
    const themeId = localStorage.getItem('selectedThemeId');
    const packageId = localStorage.getItem('selectedPackageId');
    const userType = localStorage.getItem('userType')
    useEffect(() => {
      // Experts buy licences elsewhere. Clients a counselor added (EU) can now buy packages
      // for themselves as well as receive them (Robert, 2026-10-11).
      if(userType === 'E'){
        // Drop the selection only. localStorage.clear() took the session with
        // it, so the redirect below landed on a signed-out app - a blank screen
        // moments after signing in.
        clearPackageSelection();
        window.location.href = '/overview';
      }else{
        getPackages();
      }
      }, []);
      const getPackages = async () => {
        try {
          const response = await getPackageList(themeId);
          setPackageList(response.data.data);
          const foundItem = response.data.data.find(item => item.packageId == packageId);
          // A stale or unknown selection leaves foundItem undefined; reading
          // .purchased off it threw and took the page down with it.
          setPurchased(foundItem ? foundItem.purchased : false);
        } catch (error) {
          setPackageList(null);
          console.error(error);
        }
      };
   
    return (
        <>
           {purchased ? <UserPackagePurchased /> : <UserPackageSummary />}
        </>
    );
}

export default UserPackage;
